module.exports = __webpack_public_path__ + "01_baby.234c05a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/01_baby.png
// module id = Mlos
// module chunks = 0